import { Language } from '../types';

export const ecommerceTranslations: Record<Language, Record<string, string>> = {
  en: {
    // Ecommerce Automation Page
    corePrinciples: "Core Principles",
    ecomDataDriven: "Data-Driven Automation for Ecommerce",
    ecomPrinciples: "This suite has been developed by minding the following principles:",
    profitabilityIsKey: "Profitability is Key",
    profitabilityDesc: "All solutions are aimed to help you manage and grow your profitability and invest where the ROI is.",
    reportsBeginning: "Reports are Just the Beginning",
    reportsDesc: "Real power of data comes alive when you put it to work.",
    automateData: "Automate Data Collection",
    automateDataDesc: "Automate your data collection and reporting activities with this suite. Put your time and energy into activities which move your business forward.",
    warehouseManagement: "Optimized Warehouse Management",
    warehouseDesc: "An optimized warehouse is very important for your profitability and cash. This suite will help you manage stock sellout.",
    oneStopSolution: "One-Stop Solution",
    oneStopDesc: "One stop solution for all product and ecommerce campaign management data. Look no further.",
    advancedReporting: "Advanced Reporting",
    smartAutomation: "Smart Automation",
    campaignManagement: "Campaign Management",
    productManagement: "Product Management",
    comingSoonMore: "More coming soon, long road ahead",
    ourSolutions: "Our Solutions",
    comprehensiveSuite: "Comprehensive Suite of Tools",
    suitesDesc: "This suite contains solutions coming from the Stratodata team's previous experience with delivery of custom solutions in this segment.",
    reporting: "Reporting",
    automation: "Automation",
    campaignReport: "Ecommerce Campaign Management Report",
    campaignReportDesc: "Integrated marketing, web and sales data for optimal decision making",
    campaignBullet1: "Data on marketing, web and internal sales and margin data integrated",
    campaignBullet2: "Organized by your own custom channel and platform mapping",
    campaignBullet3: "Daily performance of your sites and channels, enable you to make the right decisions over and over",
    campaignBullet4: "Maximize growth while controlling profitability on campaign level",
    productControlPanel: "Product Management Control Panel",
    productControlDesc: "Comprehensive product performance and stock management solution",
    productBullet1: "Combination of sales & stock metrics, core product management KPIs as WOH calculated",
    productBullet2: "Data presented on own product catalogue, KPIs drillable on all levels (from EAN all the way to top category or brand)",
    productBullet3: "Marketing profitability as key profit metric, lower levels of profitability available optionally",
    productBullet4: "Visibility on web and PPC data, competitor prices can be included",
    productBullet5: "All data organized in one management dashboard with daily data freshness",
    autopricing: "Autopricing",
    autopricingDesc: "Automated pricing algorithm to optimize your product prices",
    autopricingText: "Automated pricing algorithm which sets prices of your products. The suite offers off the shelf pre-made autopricing logic, which utilizes connected data from marketing, web and ERP. Customizations on this base logic can be done per your request.",
    autopricingLogic: "The off-the-shelf autopricing logic utilizes:",
    historyProduct: "History of product sales",
    currentProduct: "Current product stock",
    marketingPerformance: "Marketing performance",
    webPerformance: "Web performance",
    competitorPrices: "Competitor prices (optional)",
    managementInterface: "Management interface is part of the solution. This enables you to manage the automated solution - work is done by the data, but you stay in the driver seat.",
    productBidder: "Product Bidder",
    bidderDesc: "Automatically optimize your PPC campaigns based on product performance",
    bidderText: "Thanks to the advanced data integration this suite offers, you can take advantage of automated product sorting into PPC campaigns. Invest where the ROI is, lay out your products across various campaigns in a pre-defined manner and take control of the PPC machine.",
    useCases: "Use cases include:",
    productPromotion: "Product promotion",
    promotionDesc: "product is selling, but it is receiving sub-par exposure. Move to more aggressive campaign to drive additional traffic and ultimately sales.",
    productExclusion: "Product exclusion",
    exclusionDesc: "product profitability is very low. Investment goes in the wrong direction, we are burning money. Let's hold it back.",
    workstreams: "Workstreams",
    ourVision: "Our Vision",
    continuousGrowth: "Continuous Growth & Innovation",
    workstreamVision: "Our aim for the workstream library is to grow over time and to maximize the value it provides to our customers and partners.",
    knowledgeExpansion: "Knowledge Expansion",
    expansionDesc: "Our workstream library grows with each project, incorporating new insights and best practices from across the ecommerce ecosystem.",
    customSolutions: "Custom Solutions",
    customDesc: "We're eager to develop new solutions for your unique business challenges, expanding our capabilities with each partnership.",
    valueMaximization: "Value Maximization",
    valueDesc: "With each iteration, we refine our approach to deliver greater value, efficiency, and results for our customers and partners.",
    dataDashboard: "Data Dashboard",
    interactiveAnalytics: "Interactive Ecommerce Analytics",
    dashboardDesc: "Explore our interactive dashboard with real-time data visualization for ecommerce performance metrics.",
    pricing: "Pricing",
    choosePlan: "Choose Your Plan",
    pricingDesc: "We offer flexible pricing tiers to suit businesses of all sizes. Start with the plan that fits your current needs and scale up as you grow.",
    starter: "Starter",
    starterOrders: "Up to 8k orders / month",
    perMonth: "per month",
    basicReporting: "Basic reporting",
    coreAutomations: "Core automations",
    emailSupport: "Email support",
    contactSales: "Contact Sales",
    grower: "Grower",
    growerOrders: "Up to 20k orders / month",
    fullAutomation: "Full automation suite",
    priorityEmail: "Priority email support",
    quarterlyStrategy: "Quarterly strategy calls",
    player: "Player",
    playerOrders: "Up to 50k orders / month",
    popular: "Popular",
    premiumReporting: "Premium reporting",
    advancedAutomation: "Advanced automation suite",
    dedicatedManager: "Dedicated account manager",
    monthlyStrategy: "Monthly strategy calls",
    customReporting: "Custom reporting",
    enterprise: "Enterprise",
    unlimitedOrders: "Unlimited orders",
    custom: "Custom",
    contactPricing: "contact for pricing",
    enterpriseReporting: "Enterprise-grade reporting",
    customAutomation: "Custom automation development",
    prioritySupport: "24/7 priority support",
    dedicatedTeam: "Dedicated team",
    customIntegration: "Custom integration",
    slaGuarantees: "SLA guarantees",
    getStarted: "Get Started",
    readyTransform: "Ready to Transform Your Ecommerce Operations?",
    contactText: "Contact us today to discuss how our Ecommerce Automation Suite can help you achieve better profitability and growth. Our team of experts is ready to guide you through the implementation process.",
    whyChooseSuite: "Why Choose Our Automation Suite?",
    developmentText: "We are very much in development, so expect other cool features to arrive soon! Cheers to the datadriven future!",
    provenResults: "Proven results with ecommerce retailers",
    continuousDevelopment: "Continuous development of new features",
    expertSupport: "Expert support throughout implementation and beyond",
  },
  de: {
    // Ecommerce Automation Page
    corePrinciples: "Grundprinzipien",
    ecomDataDriven: "Datengesteuerte Automatisierung für E-Commerce",
    ecomPrinciples: "Diese Suite wurde unter Berücksichtigung der folgenden Prinzipien entwickelt:",
    profitabilityIsKey: "Rentabilität ist der Schlüssel",
    profitabilityDesc: "Alle Lösungen zielen darauf ab, Ihnen zu helfen, Ihre Rentabilität zu verwalten und zu steigern und dort zu investieren, wo der ROI ist.",
    reportsBeginning: "Berichte sind nur der Anfang",
    reportsDesc: "Die wahre Kraft der Daten entfaltet sich, wenn Sie sie zur Arbeit einsetzen.",
    automateData: "Automatisieren Sie die Datenerfassung",
    automateDataDesc: "Automatisieren Sie Ihre Datenerfassung und Berichtsaktivitäten mit dieser Suite. Investieren Sie Ihre Zeit und Energie in Aktivitäten, die Ihr Geschäft voranbringen.",
    warehouseManagement: "Optimiertes Lagerbestandsmanagement",
    warehouseDesc: "Ein optimiertes Lager ist sehr wichtig für Ihre Rentabilität und Ihr Kapital. Diese Suite hilft Ihnen, den Lagerbestand zu verwalten.",
    oneStopSolution: "Eine Komplettlösung",
    oneStopDesc: "Eine Komplettlösung für alle Produkt- und E-Commerce-Kampagnenmanagementdaten. Suchen Sie nicht weiter.",
    advancedReporting: "Fortschrittliche Berichterstattung",
    smartAutomation: "Intelligente Automatisierung",
    campaignManagement: "Kampagnenmanagement",
    productManagement: "Produktmanagement",
    comingSoonMore: "Weitere Funktionen in Kürze, langer Weg voraus",
    ourSolutions: "Unsere Lösungen",
    comprehensiveSuite: "Umfassende Werkzeugsammlung",
    suitesDesc: "Diese Suite enthält Lösungen aus der früheren Erfahrung des Stratodata-Teams mit der Lieferung maßgeschneiderter Lösungen in diesem Segment.",
    reporting: "Berichterstattung",
    automation: "Automatisierung",
    campaignReport: "E-Commerce-Kampagnenmanagementbericht",
    campaignReportDesc: "Integrierte Marketing-, Web- und Verkaufsdaten für optimale Entscheidungsfindung",
    campaignBullet1: "Daten zu Marketing, Web und internen Verkäufen und Margen integriert",
    campaignBullet2: "Organisiert nach Ihrer eigenen benutzerdefinierten Kanal- und Plattformzuordnung",
    campaignBullet3: "Tägliche Leistung Ihrer Websites und Kanäle, ermöglicht es Ihnen, immer wieder die richtigen Entscheidungen zu treffen",
    campaignBullet4: "Maximieren Sie das Wachstum bei gleichzeitiger Kontrolle der Rentabilität auf Kampagnenebene",
    productControlPanel: "Produktmanagement-Kontrollpanel",
    productControlDesc: "Umfassende Produktleistungs- und Bestandsmanagementlösung",
    productBullet1: "Kombination von Verkaufs- und Bestandsmetriken, Kern-Produktmanagement-KPIs wie WOH berechnet",
    productBullet2: "Daten auf eigenem Produktkatalog präsentiert, KPIs auf allen Ebenen detaillierbar (von EAN bis hin zur obersten Kategorie oder Marke)",
    productBullet3: "Marketingrentabilität als zentrale Gewinnkennzahl, niedrigere Rentabilitätsebenen optional verfügbar",
    productBullet4: "Einblick in Web- und PPC-Daten, Wettbewerberpreise können einbezogen werden",
    productBullet5: "Alle Daten in einem Management-Dashboard mit täglicher Datenaktualität organisiert",
    autopricing: "Automatische Preisgestaltung",
    autopricingDesc: "Automatisierter Preisalgorithmus zur Optimierung Ihrer Produktpreise",
    autopricingText: "Automatisierter Preisalgorithmus, der die Preise Ihrer Produkte festlegt. Die Suite bietet vorgefertigte Logik für automatische Preisgestaltung, die verbundene Daten aus Marketing, Web und ERP nutzt. Anpassungen an dieser Basislogik können auf Anfrage durchgeführt werden.",
    autopricingLogic: "Die vorgefertigte automatische Preisgestaltungslogik nutzt:",
    historyProduct: "Verkaufshistorie des Produkts",
    currentProduct: "Aktueller Produktbestand",
    marketingPerformance: "Marketingleistung",
    webPerformance: "Webleistung",
    competitorPrices: "Wettbewerberpreise (optional)",
    managementInterface: "Management-Schnittstelle ist Teil der Lösung. Dies ermöglicht es Ihnen, die automatisierte Lösung zu verwalten - die Arbeit wird von den Daten erledigt, aber Sie bleiben am Steuer.",
    productBidder: "Produkt-Bieter",
    bidderDesc: "Optimieren Sie Ihre PPC-Kampagnen automatisch basierend auf der Produktleistung",
    bidderText: "Dank der fortschrittlichen Datenintegration, die diese Suite bietet, können Sie von der automatisierten Produktsortierung in PPC-Kampagnen profitieren. Investieren Sie, wo der ROI ist, verteilen Sie Ihre Produkte auf verschiedene Kampagnen in vordefinierter Weise und übernehmen Sie die Kontrolle über die PPC-Maschine.",
    useCases: "Anwendungsfälle umfassen:",
    productPromotion: "Produktwerbung",
    promotionDesc: "Das Produkt verkauft sich, erhält aber unterdurchschnittliche Aufmerksamkeit. Wechseln Sie zu einer aggressiveren Kampagne, um zusätzlichen Traffic und letztendlich Verkäufe zu generieren.",
    productExclusion: "Produktausschluss",
    exclusionDesc: "Die Produktrentabilität ist sehr niedrig. Die Investition geht in die falsche Richtung, wir verbrennen Geld. Lassen Sie es uns zurückhalten.",
    workstreams: "Arbeitsabläufe",
    ourVision: "Unsere Vision",
    continuousGrowth: "Kontinuierliches Wachstum & Innovation",
    workstreamVision: "Unser Ziel für die Arbeitsablaufbibliothek ist es, im Laufe der Zeit zu wachsen und den Wert zu maximieren, den sie unseren Kunden und Partnern bietet.",
    knowledgeExpansion: "Wissenserweiterung",
    expansionDesc: "Unsere Arbeitsablaufbibliothek wächst mit jedem Projekt und integriert neue Erkenntnisse und Best Practices aus dem gesamten E-Commerce-Ökosystem.",
    customSolutions: "Maßgeschneiderte Lösungen",
    customDesc: "Wir sind bestrebt, neue Lösungen für Ihre einzigartigen Geschäftsherausforderungen zu entwickeln und unsere Fähigkeiten mit jeder Partnerschaft zu erweitern.",
    valueMaximization: "Wertmaximierung",
    valueDesc: "Mit jeder Iteration verfeinern wir unseren Ansatz, um größeren Wert, Effizienz und Ergebnisse für unsere Kunden und Partner zu liefern.",
    dataDashboard: "Daten-Dashboard",
    interactiveAnalytics: "Interaktive E-Commerce-Analyse",
    dashboardDesc: "Erkunden Sie unser interaktives Dashboard mit Echtzeit-Datenvisualisierung für E-Commerce-Leistungsmetriken.",
    pricing: "Preisgestaltung",
    choosePlan: "Wählen Sie Ihren Plan",
    pricingDesc: "Wir bieten flexible Preisstufen, die zu Unternehmen aller Größen passen. Beginnen Sie mit dem Plan, der Ihren aktuellen Bedürfnissen entspricht, und skalieren Sie nach oben, wenn Sie wachsen.",
    starter: "Starter",
    starterOrders: "Bis zu 8.000 Bestellungen / Monat",
    perMonth: "pro Monat",
    basicReporting: "Grundlegende Berichterstattung",
    coreAutomations: "Kernautomatisierungen",
    emailSupport: "E-Mail-Support",
    contactSales: "Vertrieb kontaktieren",
    grower: "Wachstum",
    growerOrders: "Bis zu 20.000 Bestellungen / Monat",
    fullAutomation: "Vollständige Automatisierungssuite",
    priorityEmail: "Prioritäts-E-Mail-Support",
    quarterlyStrategy: "Vierteljährliche Strategiegespräche",
    player: "Player",
    playerOrders: "Bis zu 50.000 Bestellungen / Monat",
    popular: "Beliebt",
    premiumReporting: "Premium-Berichterstattung",
    advancedAutomation: "Fortgeschrittene Automatisierungssuite",
    dedicatedManager: "Dedizierter Account Manager",
    monthlyStrategy: "Monatliche Strategiegespräche",
    customReporting: "Benutzerdefinierte Berichterstattung",
    enterprise: "Unternehmen",
    unlimitedOrders: "Unbegrenzte Bestellungen",
    custom: "Individuell",
    contactPricing: "Kontakt für Preisgestaltung",
    enterpriseReporting: "Unternehmensklasse-Berichterstattung",
    customAutomation: "Benutzerdefinierte Automatisierungsentwicklung",
    prioritySupport: "24/7 Prioritätssupport",
    dedicatedTeam: "Dediziertes Team",
    customIntegration: "Benutzerdefinierte Integration",
    slaGuarantees: "SLA-Garantien",
    getStarted: "Loslegen",
    readyTransform: "Bereit, Ihren E-Commerce-Betrieb zu transformieren?",
    contactText: "Kontaktieren Sie uns noch heute, um zu besprechen, wie unsere E-Commerce-Automatisierungssuite Ihnen helfen kann, bessere Rentabilität und Wachstum zu erzielen. Unser Expertenteam steht bereit, Sie durch den Implementierungsprozess zu führen.",
    whyChooseSuite: "Warum unsere Automatisierungssuite wählen?",
    developmentText: "Wir befinden uns in voller Entwicklung, erwarten Sie also bald weitere coole Funktionen! Prost auf die datengesteuerte Zukunft!",
    provenResults: "Bewährte Ergebnisse mit E-Commerce-Händlern",
    continuousDevelopment: "Kontinuierliche Entwicklung neuer Funktionen",
    expertSupport: "Expertensupport während der Implementierung und darüber hinaus",
  },
  sk: {
    // Ecommerce Automation Page - using English as fallback for now
    corePrinciples: "Základné princípy",
    ecomDataDriven: "Dátovo riadená automatizácia pre e-commerce",
    ecomPrinciples: "Tento balík bol vyvinutý s ohľadom na nasledujúce princípy:",
    profitabilityIsKey: "Ziskovosť je kľúčová",
    profitabilityDesc: "All solutions are aimed to help you manage and grow your profitability and invest where the ROI is.",
    // Using English fallbacks for all other keys
    reportsBeginning: "Reports are Just the Beginning",
    reportsDesc: "Real power of data comes alive when you put it to work.",
    automateData: "Automate Data Collection",
    automateDataDesc: "Automate your data collection and reporting activities with this suite. Put your time and energy into activities which move your business forward.",
    warehouseManagement: "Optimized Warehouse Management",
    warehouseDesc: "An optimized warehouse is very important for your profitability and cash. This suite will help you manage stock sellout.",
    oneStopSolution: "One-Stop Solution",
    oneStopDesc: "One stop solution for all product and ecommerce campaign management data. Look no further.",
    advancedReporting: "Advanced Reporting",
    smartAutomation: "Smart Automation",
    campaignManagement: "Campaign Management",
    productManagement: "Product Management",
    comingSoonMore: "More coming soon, long road ahead",
    ourSolutions: "Our Solutions",
    comprehensiveSuite: "Comprehensive Suite of Tools",
    suitesDesc: "This suite contains solutions coming from the Stratodata team's previous experience with delivery of custom solutions in this segment.",
    reporting: "Reporting",
    automation: "Automation",
    campaignReport: "Ecommerce Campaign Management Report",
    campaignReportDesc: "Integrated marketing, web and sales data for optimal decision making",
    campaignBullet1: "Data on marketing, web and internal sales and margin data integrated",
    campaignBullet2: "Organized by your own custom channel and platform mapping",
    campaignBullet3: "Daily performance of your sites and channels, enable you to make the right decisions over and over",
    campaignBullet4: "Maximize growth while controlling profitability on campaign level",
    productControlPanel: "Product Management Control Panel",
    productControlDesc: "Comprehensive product performance and stock management solution",
    productBullet1: "Combination of sales & stock metrics, core product management KPIs as WOH calculated",
    productBullet2: "Data presented on own product catalogue, KPIs drillable on all levels (from EAN all the way to top category or brand)",
    productBullet3: "Marketing profitability as key profit metric, lower levels of profitability available optionally",
    productBullet4: "Visibility on web and PPC data, competitor prices can be included",
    productBullet5: "All data organized in one management dashboard with daily data freshness",
    autopricing: "Autopricing",
    autopricingDesc: "Automated pricing algorithm to optimize your product prices",
    autopricingText: "Automated pricing algorithm which sets prices of your products. The suite offers off the shelf pre-made autopricing logic, which utilizes connected data from marketing, web and ERP. Customizations on this base logic can be done per your request.",
    autopricingLogic: "The off-the-shelf autopricing logic utilizes:",
    historyProduct: "History of product sales",
    currentProduct: "Current product stock",
    marketingPerformance: "Marketing performance",
    webPerformance: "Web performance",
    competitorPrices: "Competitor prices (optional)",
    managementInterface: "Management interface is part of the solution. This enables you to manage the automated solution - work is done by the data, but you stay in the driver seat.",
    productBidder: "Product Bidder",
    bidderDesc: "Automatically optimize your PPC campaigns based on product performance",
    bidderText: "Thanks to the advanced data integration this suite offers, you can take advantage of automated product sorting into PPC campaigns. Invest where the ROI is, lay out your products across various campaigns in a pre-defined manner and take control of the PPC machine.",
    useCases: "Use cases include:",
    productPromotion: "Product promotion",
    promotionDesc: "product is selling, but it is receiving sub-par exposure. Move to more aggressive campaign to drive additional traffic and ultimately sales.",
    productExclusion: "Product exclusion",
    exclusionDesc: "product profitability is very low. Investment goes in the wrong direction, we are burning money. Let's hold it back.",
    workstreams: "Workstreams",
    ourVision: "Our Vision",
    continuousGrowth: "Continuous Growth & Innovation",
    workstreamVision: "Our aim for the workstream library is to grow over time and to maximize the value it provides to our customers and partners.",
    knowledgeExpansion: "Knowledge Expansion",
    expansionDesc: "Our workstream library grows with each project, incorporating new insights and best practices from across the ecommerce ecosystem.",
    customSolutions: "Custom Solutions",
    customDesc: "We're eager to develop new solutions for your unique business challenges, expanding our capabilities with each partnership.",
    valueMaximization: "Value Maximization",
    valueDesc: "With each iteration, we refine our approach to deliver greater value, efficiency, and results for our customers and partners.",
    dataDashboard: "Data Dashboard",
    interactiveAnalytics: "Interactive Ecommerce Analytics",
    dashboardDesc: "Explore our interactive dashboard with real-time data visualization for ecommerce performance metrics.",
    pricing: "Pricing",
    choosePlan: "Choose Your Plan",
    pricingDesc: "We offer flexible pricing tiers to suit businesses of all sizes. Start with the plan that fits your current needs and scale up as you grow.",
    starter: "Starter",
    starterOrders: "Up to 8k orders / month",
    perMonth: "per month",
    basicReporting: "Basic reporting",
    coreAutomations: "Core automations",
    emailSupport: "Email support",
    contactSales: "Contact Sales",
    grower: "Grower",
    growerOrders: "Up to 20k orders / month",
    fullAutomation: "Full automation suite",
    priorityEmail: "Priority email support",
    quarterlyStrategy: "Quarterly strategy calls",
    player: "Player",
    playerOrders: "Up to 50k orders / month",
    popular: "Popular",
    premiumReporting: "Premium reporting",
    advancedAutomation: "Advanced automation suite",
    dedicatedManager: "Dedicated account manager",
    monthlyStrategy: "Monthly strategy calls",
    customReporting: "Custom reporting",
    enterprise: "Enterprise",
    unlimitedOrders: "Unlimited orders",
    custom: "Custom",
    contactPricing: "contact for pricing",
    enterpriseReporting: "Enterprise-grade reporting",
    customAutomation: "Custom automation development",
    prioritySupport: "24/7 priority support",
    dedicatedTeam: "Dedicated team",
    customIntegration: "Custom integration",
    slaGuarantees: "SLA guarantees",
    getStarted: "Get Started",
    readyTransform: "Ready to Transform Your Ecommerce Operations?",
    contactText: "Contact us today to discuss how our Ecommerce Automation Suite can help you achieve better profitability and growth. Our team of experts is ready to guide you through the implementation process.",
    whyChooseSuite: "Why Choose Our Automation Suite?",
    developmentText: "We are very much in development, so expect other cool features to arrive soon! Cheers to the datadriven future!",
    provenResults: "Proven results with ecommerce retailers",
    continuousDevelopment: "Continuous development of new features",
    expertSupport: "Expert support throughout implementation and beyond",
  },
  cs: {
    // Ecommerce Automation Page
    corePrinciples: "Základní principy",
    ecomDataDriven: "Datově řízená automatizace pro e-commerce",
    ecomPrinciples: "Tento balíček byl vyvinut s ohledem na následující principy:",
    profitabilityIsKey: "Ziskovost je klíčová",
    profitabilityDesc: "Všechna řešení jsou zaměřena na pomoc při řízení a růstu vaší ziskovosti a investování tam, kde je ROI.",
    reportsBeginning: "Reporty jsou jen začátek",
    reportsDesc: "Skutečná síla dat ožívá, když je dáte do práce.",
    automateData: "Automatizujte sběr dat",
    automateDataDesc: "Automatizujte své aktivity sběru dat a reportování s tímto balíčkem. Věnujte svůj čas a energii aktivitám, které posouvají vaše podnikání vpřed.",
    warehouseManagement: "Optimalizovaná správa skladu",
    warehouseDesc: "Optimalizovaný sklad je velmi důležitý pro vaši ziskovost a hotovost. Tento balíček vám pomůže řídit výprodeje zásob.",
    oneStopSolution: "Komplexní řešení",
    oneStopDesc: "Jedno komplexní řešení pro všechna data správy produktů a e-commerce kampaní. Nemusíte hledat dál.",
    advancedReporting: "Pokročilé reportování",
    smartAutomation: "Chytrá automatizace",
    campaignManagement: "Správa kampaní",
    productManagement: "Správa produktů",
    comingSoonMore: "Více již brzy, dlouhá cesta před námi",
    ourSolutions: "Naše řešení",
    comprehensiveSuite: "Komplexní sada nástrojů",
    suitesDesc: "Tento balíček obsahuje řešení vycházející z předchozích zkušeností týmu Stratodata s dodávkou vlastních řešení v tomto segmentu.",
    reporting: "Reportování",
    automation: "Automatizace",
    campaignReport: "Report správy e-commerce kampaní",
    campaignReportDesc: "Integrovaná marketingová, webová a prodejní data pro optimální rozhodování",
    campaignBullet1: "Integrovaná data o marketingu, webu a interních prodejích a maržích",
    campaignBullet2: "Organizováno podle vlastního vlastního mapování kanálů a platforem",
    campaignBullet3: "Denní výkon vašich webů a kanálů umožňuje opakovaně činit správná rozhodnutí",
    campaignBullet4: "Maximalizujte růst při kontrole ziskovosti na úrovni kampaně",
    productControlPanel: "Řídicí panel správy produktů",
    productControlDesc: "Komplexní řešení výkonu produktů a správy zásob",
    productBullet1: "Kombinace metrik prodeje a zásob, základní KPIs správy produktů jako WOH vypočítané",
    productBullet2: "Data prezentována na vlastním produktovém katalogu, KPIs prozkoumatelné na všech úrovních (od EAN až po nejvyšší kategorii nebo značku)",
    productBullet3: "Marketingová ziskovost jako klíčová zisková metrika, nižší úrovně ziskovosti dostupné volitelně",
    productBullet4: "Viditelnost webových a PPC dat, ceny konkurentů mohou být zahrnuty",
    productBullet5: "Všechna data organizována v jednom řídicím dashboardu s denní čerstvostí dat",
    autopricing: "Automatické cenotvorba",
    autopricingDesc: "Automatický cenový algoritmus k optimalizaci cen vašich produktů",
    autopricingText: "Automatický cenový algoritmus, který nastavuje ceny vašich produktů. Balíček nabízí připravenou logiku automatické cenotvorby, která využívá propojená data z marketingu, webu a ERP. Přizpůsobení této základní logiky lze provést na vaši žádost.",
    autopricingLogic: "Připravená logika automatické cenotvorby využívá:",
    historyProduct: "Historie prodeje produktu",
    currentProduct: "Současný stav zásob produktu",
    marketingPerformance: "Marketingový výkon",
    webPerformance: "Webový výkon",
    competitorPrices: "Ceny konkurentů (volitelné)",
    managementInterface: "Řídicí rozhraní je součástí řešení. To vám umožňuje řídit automatizované řešení - práce je prováděna daty, ale vy zůstáváte v řidičském sedadle.",
    productBidder: "Produktový nabídkař",
    bidderDesc: "Automaticky optimalizujte své PPC kampaně na základě výkonu produktů",
    bidderText: "Díky pokročilé integraci dat, kterou tento balíček nabízí, můžete využít automatické třídění produktů do PPC kampaní. Investujte tam, kde je ROI, rozložte své produkty napříč různými kampaněmi předem definovaným způsobem a převezměte kontrolu nad PPC strojem.",
    useCases: "Případy užití zahrnují:",
    productPromotion: "Propagace produktu",
    promotionDesc: "produkt se prodává, ale dostává podprůměrnou expozici. Přesuňte do agresivnější kampaně, abyste získali další provoz a nakonec prodeje.",
    productExclusion: "Vyloučení produktu",
    exclusionDesc: "ziskovost produktu je velmi nízká. Investice jde špatným směrem, pálíme peníze. Zadržme to.",
    workstreams: "Pracovní toky",
    ourVision: "Naše vize",
    continuousGrowth: "Kontinuální růst a inovace",
    workstreamVision: "Naším cílem pro knihovnu pracovních toků je růst v čase a maximalizovat hodnotu, kterou poskytuje našim zákazníkům a partnerům.",
    knowledgeExpansion: "Rozšíření znalostí",
    expansionDesc: "Naše knihovna pracovních toků roste s každým projektem, začleňuje nové poznatky a osvědčené postupy z celého ekosystému e-commerce.",
    customSolutions: "Vlastní řešení",
    customDesc: "Jsme nadšeni vyvíjet nová řešení pro vaše jedinečné obchodní výzvy a rozšiřovat naše schopnosti s každým partnerstvím.",
    valueMaximization: "Maximalizace hodnoty",
    valueDesc: "S každou iterací zdokonalujeme náš přístup, abychom dodávali větší hodnotu, efektivitu a výsledky pro naše zákazníky a partnery.",
    dataDashboard: "Datový dashboard",
    interactiveAnalytics: "Interaktivní e-commerce analýza",
    dashboardDesc: "Prozkoumejte náš interaktivní dashboard s vizualizací dat v reálném čase pro metriky výkonu e-commerce.",
    pricing: "Cenotvorba",
    choosePlan: "Vyberte si svůj plán",
    pricingDesc: "Nabízíme flexibilní cenové úrovně, které vyhovují firmám všech velikostí. Začněte s plánem, který vyhovuje vašim současným potřebám, a škálujte nahoru, jak rostete.",
    starter: "Začátečník",
    starterOrders: "Až 8k objednávek / měsíc",
    perMonth: "měsíčně",
    basicReporting: "Základní reportování",
    coreAutomations: "Základní automatizace",
    emailSupport: "Emailová podpora",
    contactSales: "Kontaktovat prodej",
    grower: "Růst",
    growerOrders: "Až 20k objednávek / měsíc",
    fullAutomation: "Kompletní automatizační balíček",
    priorityEmail: "Prioritní emailová podpora",
    quarterlyStrategy: "Čtvrtletní strategická jednání",
    player: "Hráč",
    playerOrders: "Až 50k objednávek / měsíc",
    popular: "Populární",
    premiumReporting: "Prémiové reportování",
    advancedAutomation: "Pokročilý automatizační balíček",
    dedicatedManager: "Vyhrazený account manager",
    monthlyStrategy: "Měsíční strategická jednání",
    customReporting: "Vlastní reportování",
    enterprise: "Enterprise",
    unlimitedOrders: "Neomezené objednávky",
    custom: "Vlastní",
    contactPricing: "kontaktovat pro cenovou nabídku",
    enterpriseReporting: "Reportování na úrovni enterprise",
    customAutomation: "Vývoj vlastní automatizace",
    prioritySupport: "24/7 prioritní podpora",
    dedicatedTeam: "Vyhrazený tým",
    customIntegration: "Vlastní integrace",
    slaGuarantees: "SLA záruky",
    getStarted: "Začít",
    readyTransform: "Připraveni transformovat své e-commerce operace?",
    contactText: "Kontaktujte nás ještě dnes a prodiskutujte, jak vám náš balíček automatizace e-commerce může pomoci dosáhnout lepší ziskovosti a růstu. Náš tým odborníků je připraven vás provést procesem implementace.",
    whyChooseSuite: "Proč si vybrat náš automatizační balíček?",
    developmentText: "Jsme velmi ve vývoji, takže očekávejte další skvělé funkce, které brzy přijdou! Na zdraví datově řízené budoucnosti!",
    provenResults: "Osvědčené výsledky s e-commerce maloobchodníky",
    continuousDevelopment: "Kontinuální vývoj nových funkcí",
    expertSupport: "Odborná podpora během implementace a dál",
  }
};
